const AUTH_INFO = 'index/AUTH_INFO' as const;
const SET_AUTH_INFO = 'index/SET_AUTH_INFO' as const;
export const getAuthInfo = () => ({
  type: AUTH_INFO,
});

export const setAuthInfo = (state: AuthState) => ({
  type: SET_AUTH_INFO,
  payload: state,
});

type AuthAction = ReturnType<typeof getAuthInfo> | ReturnType<typeof setAuthInfo>;

export type AuthState = {
  auth: string;
  point: string;
  date?: string;
};
const initialState: AuthState = {
  auth: '',
  point: '',
  date: '',
};

function auth(state: AuthState = initialState, action: AuthAction): any {
  switch (action.type) {
    case AUTH_INFO:
      return { ...state };
    case SET_AUTH_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default auth;
